import { AxiosStatic } from "axios";
import { cloneDeep, toLower } from "lodash";
import { RefreshTokenData, ServerErrorState, fetchLogout } from "../../redux";

const generateTrailInfo = () => {
  const userAgent = window?.navigator?.userAgent;
  const hostName = window?.location?.hostname;
  return {
    useragent: userAgent,
    hostname: hostName,
  };
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export function setupAxios(
  axios: AxiosStatic,
  apiUrl: string,
  store?: any,
  loadingActions?: any,
  serverErrorActions?: any,
  authActions?: any,
  refreshToken?: any,
  redirectUri?: string,
  urlLogout?: string
) {
  axios.interceptors.request.use(
    (config: any) => {
      config.paramsSerializer = {
        indexes: null,
      };
      const {
        auth: { info },
      } = store.getState();
      if (info?.accessToken && !config.params?.mock) {
        config.headers.Authorization = `Bearer ${info.accessToken}`;
      }

      // if (config.params?.mock) {
      //   config.baseURL = mockUrl;
      // } else {
      config.baseURL = apiUrl;

      //}
      const { dispatch } = store;
      if (!config.params?.hiddeLoading) {
        dispatch(loadingActions.startCall(config.url));
      }

      // Add trail information to request
      const method = toLower(config.method);
      if (method === "post" || method === "put" || method === "delete") {
        if (config.data instanceof FormData) {
          config.data.append("trial", JSON.stringify(generateTrailInfo()));
        } else if (!(config.data instanceof Array)) {
          config.data = { ...config.data, trial: generateTrailInfo() };
        }
      }

      return config;
    },
    (err: any) => Promise.reject(err)
  );
  axios.interceptors.response.use(
    function (response: any) {
      const { dispatch } = store;
      dispatch(loadingActions.endCall(response.config.url));
      return response;
    },
    function axiosRetryInterceptor(error: any) {
      const { dispatch } = store;
      dispatch(loadingActions.endCall(error?.config?.url));
      if (
        error?.response?.status === 400 &&
        error?.response?.data?.errors?.nonFieldError
      ) {
        // Bad request

        const message = error.response.data.errors.nonFieldError
          .map((e: any) => e.message)
          .join(" ");
        const serverError: ServerErrorState = {
          messageError: message,
          detailedMessageError: error.response.data.message,
          traceId: error.response.headers.traceid,
        };
        dispatch(serverErrorActions.showError(serverError));
      }
      if (error?.response?.status === 401) {
        // Unauthorized

        //first time
        if (!error.config._retry) {
          //try refresh token
          const {
            auth: { info },
          } = store.getState();
          const data: RefreshTokenData = {
            refreshToken: info.refreshToken,
          };
          return dispatch(refreshToken(data)).then((response: any) => {
            const originalRequest = cloneDeep(error.config);
            if (error.config.data && typeof error.config.data === "string") {
              try {
                originalRequest.data = JSON.parse(error.config.data);
              } catch (e) {
                // Ignore failed JSON.parse if the data is not a valid JSON
              }
            }
            originalRequest.headers = { ...error.config.headers };
            originalRequest._retry = true;
            //retry request
            return axios(originalRequest);
          });
        }
        //second time, not refresh
        else {
          dispatch(
            fetchLogout({
              redirectUri: redirectUri ? redirectUri : "",
              urlLogout: urlLogout ? urlLogout : "",
            })
          );
        }
      }
      if (error?.response?.status === 403) {
        // Access Denied
        window.location.replace(`/access-denied`);
      }
      if (error?.response?.status === 404) {
        // Not found
        const serverError: ServerErrorState = {
          messageError: "Server error. Not Found",
          detailedMessageError: error.message,
          traceId: error.response.headers.traceid,
        };
        dispatch(serverErrorActions.showError(serverError));
      }
      if (error?.response?.status === 500) {
        // Error
        const serverError: ServerErrorState = {
          messageError:
            "Server error. Please, try again in few minutes or contact an administrator.",
          detailedMessageError: error.message,
          traceId: error.response.headers.traceid,
        };
        if (!error.config?.params?.ignore500Errors) {
          dispatch(serverErrorActions.showError(serverError));
        }
      }
      if (!error?.response) {
        // Another Error

        const serverError: ServerErrorState = {
          messageError:
            "Server error. Please, try again in few minutes or contact an administrator.",
          detailedMessageError: error.message,
          traceId: error.response.headers.traceid,
        };
        dispatch(serverErrorActions.showError(serverError));
      }
      return Promise.reject(error);
    }
  );
}
export default setupAxios;
